<nav class="navbar navbar-expand-lg navbar-light ns-navbar sticky-top">
    <div class="container-fluid">
        <a class="navbar-brand" routerLink="/">
            <img src="/assets/images/logo_noovle.svg" alt="" height="33" class="d-inline-block align-text-top me-5" />
        </a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent" *ngIf="(fireAuth.idTokenResult | async)?.claims?.['role']">
            <ul class="navbar-nav me-auto mb-2 mb-lg-0">
                <!-- <li class="nav-item">
                    <a class="nav-link" aria-current="builder-page" routerLink="/pages" routerLinkActive="active">Page Builder</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link mx-4" aria-current="users-page" routerLink="/users" routerLinkActive="active" *ngIf="['ADMIN', 'ADMIN_VIEWER'] | roleRestriction | async">Utenze</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" aria-current="dashboards-page" routerLink="/dashboards" routerLinkActive="active" *ngIf="['ADMIN', 'ADMIN_VIEWER'] | roleRestriction | async">Dashboards</a>
                </li>
                <li class="nav-item mx-4">
                    <a class="nav-link" aria-current="auditing-page" routerLink="/auditing" routerLinkActive="active" *ngIf="['ADMIN', 'ADMIN_VIEWER'] | roleRestriction | async">Auditing</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" aria-current="custom-metric-page" routerLink="/custom-metrics" routerLinkActive="active" *ngIf="['ADMIN', 'ADMIN_VIEWER', 'EDITOR'] | roleRestriction | async">Metriche</a>
                </li> -->
                <li class="nav-item" *ngFor="let item of menu">
                    <a class="nav-link mx-2" [routerLink]="item.url" routerLinkActive="active" *ngIf="item.allowedRoles | roleRestriction | async">{{item.label}}</a>
                </li>
            </ul>
            <div ngbDropdown display="dynamic" placement="bottom-end" class="mx-3">
                <img src="{{ (fireAuth.user | async)?.photoURL || 'assets/images/userProfileIcon2.png' }}" alt="" width="35" class="align-text-top ns-user-image" id="userOption" href="#" tabindex="0" ngbDropdownToggle role="button" />
                <div ngbDropdownMenu aria-labelledby="userOption" class="dropdown-menu">
                    <b class="ms-3 mx-5">{{ (fireAuth.user | async)?.email }}</b>
                    <div class="dropdown-divider"></div>
                    <button ngbDropdownItem (click)="authService.logout()" class="ps-3">Logout</button>
                    <ng-container *ngIf="authService.providerDataUser">
                        <div class="dropdown-divider"></div>
                        <button ngbDropdownItem (click)="openResetPasswordModal()" class="ps-3">Reset password</button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</nav>
